import * as React from 'react'
import AnnouncementBanner from '../../../common/components/AnnouncementBanner/AnnouncementBanner'

export type Props = {
  shouldShowBanner: boolean
}

const AlertTypeFilterBanner = ({ shouldShowBanner }: Props) => {
  const iconProps = {
    icon: {
      name: 'warning-filled',
      fill: '#d7af49',
      size: 22
    },
  }

  if (!shouldShowBanner) {
    return null
  }

  return (
    <AnnouncementBanner {...iconProps} type="warning">
      <p>
        Use the <b>Alert Type</b> filter to view basic or advanced alerts. A unified view is currently unavailable during our migration to the Hyperforce infrastructure.
      </p>
    </AnnouncementBanner>
  )
}

export default AlertTypeFilterBanner

